import { Show } from 'solid-js';
import styles from './Pagination.module.css';

interface PaginationProps {
    page: number;
    totalPages: number;
    onChange: (next: number) => void;
    size?: 'sm';
}

export function Pagination(props: PaginationProps) {
    const btnClass = () => `btn btn-secondary${props.size === 'sm' ? ' btn-sm' : ''}`;

    return (
        <Show when={props.totalPages > 1}>
            <div class={styles.pagination}>
                <button
                    type="button"
                    class={btnClass()}
                    disabled={props.page === 0}
                    onClick={() => props.onChange(props.page - 1)}
                    aria-label="Previous page"
                >
                    <i class="fa-solid fa-chevron-left" />
                </button>
                <span class={styles.pageInfo}>{props.page + 1} / {props.totalPages}</span>
                <button
                    type="button"
                    class={btnClass()}
                    disabled={props.page >= props.totalPages - 1}
                    onClick={() => props.onChange(props.page + 1)}
                    aria-label="Next page"
                >
                    <i class="fa-solid fa-chevron-right" />
                </button>
            </div>
        </Show>
    );
}
